import HooksModalV5Key from "app/constants/HooksModalV5Key";
import { createLegacyCategoryIcon } from "app/pages/sales-intelligence/common-components/filters-panel/utils/icons";
import type { IFiltersConfigCategoryItem } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/category";
import advancedFilteringI18nKeys from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/i18n";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { openHooksModalV5 } from "app/services/ModalService";

import { appsFilterCategoryMap, type FilterCategory } from "../types/filterCategory";

export const appsCategories = {
    apps: {
        id: appsFilterCategoryMap.apps,
        order: 70,
        icon: createLegacyCategoryIcon("sidebar3-search-apps"),
        titleKey: advancedFilteringI18nKeys.category(appsFilterCategoryMap.apps),
        get isLocked() {
            return !salesSettingsHelper.isConsolidatedAppsEnabled;
        },
        onLockedClick: () => openHooksModalV5(HooksModalV5Key.AppLeadGenerator),
    },
} as const satisfies Record<FilterCategory, IFiltersConfigCategoryItem>;
